import dayjs from "dayjs";
import { z } from "zod";

export const PASSWORD_MASK = "**********";

export const PLACEHOLDER_ORGANIZATION = "Вы ещё не указали организацию";
export const PLACEHOLDER_POSITION = "Вы ещё не указали должность";
export const PLACEHOLDER_PHONE = "Вы ещё не указали номер телефона";
export const PLACEHOLDER_CORPORATE_EMAIL = "Вы ещё не указали корпоративную почту";

/** Editable work fields only; FIO is display-only (Keycloak) and stays out of PUT body. */
export const userInfoEditFormSchema = z.object({
  organization: z.string().max(500),
  position: z.string().max(255),
  contactPhone: z.string().max(50),
  corporateEmail: z.union([z.literal(""), z.email().max(255)]),
  lastName: z.string(),
  firstName: z.string(),
  middleName: z.string(),
});

export type UserInfoEditFormValues = z.infer<typeof userInfoEditFormSchema>;

export const displayProfileValue = (value: string | null | undefined, placeholder: string) => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : placeholder;
};

export const formatRegistrationDate = (value: string | null | undefined) => (value ? dayjs(value).format("DD.MM.YYYY") : "—");
